<template>
  <v-btn
    color="accent"
    :href="authorizationServerUrl"
    size="x-large"
  >
    <v-img
      :src="sorareLogo"
      alt="Sorare logo"
      height="30"
      width="30"
      class="mr-2"
    />
    Sorare
  </v-btn>
</template>

<script>
import OauthUtils from '@/services/oauth.utils';
import sorareLogo from '@/assets/sorare-logo.svg';

export default {
  name: 'SorareConnectButton',
  data() {
    return {
      sorareLogo,
    };
  },
  computed: {
    authorizationServerUrl() {
      if (import.meta.env.DEV) {
        return '/oauth/redirect?code=testcode';
      }

      return OauthUtils.authorizationServerUrl();
    },
  },
};
</script>
